<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card v-if="blog" class="blog-edit-wrapper">
      <b-tabs>
        <b-tab active>
          <template #title>
            <feather-icon icon="BookOpenIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">ویرایش بلاگ</span>
          </template>
          <!-- form -->
          <b-form class="mt-2">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="عنوان"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-input id="blog-edit-title" v-model="blog.title" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  v-if="blogCategories"
                  label="دسته بندی"
                  label-for="category"
                  class="mb-2"
                >
                  <v-select
                    id="category"
                    v-model="blog.blogCategoryId"
                    :options="blogCategories"
                    label="name"
                    :reduce="(name) => name.blogCategoryId"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <!-- Field:  description -->
              <b-col cols="12">
                <b-form-group label="توضیحات سئو" label-for="seoDesc">
                  <b-form-textarea
                    id="seoDesc"
                    v-model="blog.seoDescription"
                    rows="2"
                    placeholder="توضیحات سئو"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="خلاصه" label-for="summary">
                  <b-form-textarea
                    id="summary"
                    v-model="blog.summary"
                    rows="2"
                    placeholder="خلاصه"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="توضیحات"
                  label-for="blog-content"
                  class="mb-2"
                >
                  <ckEditorMain
                    @getEditorContent="setEditorContent"
                    :defaultContent="blog.description"
                  ></ckEditorMain>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="mb-2">
                <div class="border rounded p-2">
                  <h4 class="mb-1">پیوست عکس</h4>
                  <b-media
                    no-body
                    vertical-align="center"
                    class="flex-column flex-md-row"
                  >
                    <b-media-aside>
                      <b-img
                        ref="refPreviewEl"
                        :src="base64ImageSrc"
                        height="110"
                        width="170"
                        class="rounded mr-2 mb-1 mb-md-0"
                      />
                    </b-media-aside>
                    <b-media-body>
                      <div class="d-inline-block">
                        <b-form-file
                          ref="refInputEl"
                          accept=".jpg, .png, .gif"
                          placeholder="انتخاب عکس"
                          @input="makeBase64Pic"
                        />
                      </div>
                    </b-media-body>
                  </b-media>
                </div>
              </b-col>
              <b-col cols="4" class="my-50">
                <div class="media d-flex align-items-center">
                  <h6 class="font-weight-bolder mr-auto mb-0">
                    مقاله‌ی برگزیده باشد؟
                  </h6>
                  <b-form-checkbox
                    :checked="false"
                    switch
                    v-model="blog.isSpecified"
                  />
                </div>
              </b-col>
              <b-col cols="12" class="mt-50">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-1"
                  @click="updateBlog"
                >
                  ذخیره تغییرات
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="SearchIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">ویرایش جزئیات سئو</span>
          </template>
          <b-form class="mt-2">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="سئو تایتل (50 تا 60 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-input id="blog-edit-title" v-model="blog.seoTitle" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="سئو URL (تا 75 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-input id="blog-edit-title" v-model="blog.seourl" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group
                  label="سئو Description (155 تا 160 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-textarea
                    id="blog-edit-title"
                    v-model="blog.seoDescription"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="لینک کنونیکال"
                  label-for="blog-edit-canonical"
                  class="mb-2"
                >
                  <b-form-input
                    id="blog-edit-canonical"
                    v-model="blog.canonical"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <h4 class="mb-1">پیش نمایش</h4>
              </b-col>
              <b-col md="12">
                <div class="serp-box">
                  <h3>
                    <a href="#" target="_blank"
                      >{{ blog.seoTitle }} | فرادیدار</a
                    >
                  </h3>

                  <cite dir="ltr">
                    www.faradidar.com/blogs/{{ blog.blogId }}/{{ blog.seourl }}
                  </cite>

                  <p v-html="blog.seoDescription"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mt-50">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-1"
                  @click="updateBlogSeo"
                >
                  ذخیره تغییرات
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
      <!--/ form -->
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BMedia,
  BAvatar,
  BCardText,
  BMediaAside,
  BMediaBody,
  BForm,
  BFormCheckbox,
  BRow,
  BCol,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BImg,
  BFormFile,
  BLink,
  BButton,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import BlogGetByIdRequest from "@/libs/Api/Blog/BlogGetByIdRequest";
import BlogCategoryGetAllRequest from "@/libs/Api/Blog/BlogCategoryGetAllRequest";
import BlogUpdateBlogRequest from "@/libs/Api/Blog/BlogUpdateBlogRequest";
import BlogSeoUpdateRequest from "@/libs/Api/Blog/BlogSeoUpdateRequest";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import ckEditorMain from "@core/components/ckEditorMain.vue";

export default {
  title: "ویرایش بلاگ - پنل ادمین فرادیدار",
  components: {
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BMediaAside,
    BMediaBody,
    BForm,
    BLink,
    BImg,
    BRow,
    BCol,
    BTabs,
    BTab,
    BButton,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormTextarea,
    BFormCheckbox,
    BOverlay,
    vSelect,
    ckEditorMain,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      blog: null,
      blogId: this.$route.params.id,
      blogCategories: null,
      base64ImageSrc: null,
      blogFile: null,
      tempSeoDesc: null,
      isLoading: null,
    };
  },
  async created() {
    await this.getBlog();
    await this.getBlogCategories();
    // this.$http.get("/blog/list/data/edit").then((res) => {
    //   this.blogEdit = res.data;
    // });
  },
  methods: {
    setEditorContent(content) {
      this.blog.description = content;
    },
    async updateBlogSeo() {
      try {
        this.isLoading = true;
        let _this = this;
        let blogSeoUpdateRequest = new BlogSeoUpdateRequest(_this);
        blogSeoUpdateRequest.setParams(_this.blog);
        await blogSeoUpdateRequest.fetch(
          function (content) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `عملیات موفق`,
                icon: "CheckIcon",
                variant: "success",
                text: `تغییرات انجام شد.`,
              },
            });
            _this.getBlog();
          },
          function (error) {
            console.log(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getBlog() {
      try {
        this.isLoading = true;
        let _this = this;
        let blogGetByIdRequest = new BlogGetByIdRequest(_this);
        blogGetByIdRequest.setId(_this.blogId);
        await blogGetByIdRequest.fetch(
          function (content) {
            _this.blog = content;
            _this.tempSeoDesc = _this.blog.seoDescription;
            _this.base64ImageSrc =
              "https://api.faradidar.com/" + _this.blog.fileData;
            _this.blog.fileData = "";
          },
          function () {
            console.log("Error");
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getBlogCategories() {
      let _this = this;
      let blogCategoryGetAllRequest = new BlogCategoryGetAllRequest(_this);
      await blogCategoryGetAllRequest.fetch(
        function (content) {
          _this.blogCategories = content;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async updateBlog() {
      try {
        this.blog.seoDescription = this.tempSeoDesc;
        this.isLoading = true;
        let _this = this;
        let blogUpdateBlogRequest = new BlogUpdateBlogRequest(_this);
        blogUpdateBlogRequest.setParams(_this.blog);
        await blogUpdateBlogRequest.fetch(
          async function (content) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `عملیات موفق`,
                icon: "CheckIcon",
                variant: "success",
                text: `تغییرات انجام شد.`,
              },
            });
            await _this.getBlog();
            await _this.getBlogCategories();
          },
          function (error) {
            console.log(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onerror = reject;
        fr.onload = () => {
          resolve(fr.result.split(",")[1]);
        };
        fr.readAsDataURL(file);
      });
    },
    async makeBase64Pic() {
      const _this = this;
      let file = _this.$refs.refInputEl.files[0];
      _this.base64ImageSrc = URL.createObjectURL(file);
      const result = await _this.readAsDataURL(file);
      _this.blog.fileData = result;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/pages/page-blog.scss";
</style>
<style scoped>
.serp-box {
  font-family: Arial, sans-serif;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 10px 0;
  color: #222;
  border-radius: 2px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.serp-box h3 {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;

  display: block;
  overflow: hidden;

  margin: 0;
  padding: 11px 16px 0 16px;

  text-align: left;
  white-space: nowrap;
  text-transform: none;
  text-overflow: ellipsis;

  -moz-text-overflow: ellipsis;
}

.serp-box h3 a {
  white-space: nowrap;
  text-decoration: none;

  color: #1a0dab;
}

.serp-box cite {
  font-size: 14px;
  font-style: normal;
  line-height: 16px;

  display: block;

  padding: 0 16px 0 16px;

  color: #006621;
}

.serp-box p {
  font-size: 13px;
  line-height: 1.4;

  margin: 1px 0 0 0;
  padding: 0 16px 11px 16px;

  cursor: text;
  word-wrap: break-word;
}

.serp-box p a {
  text-decoration: none;
  pointer-events: none;

  color: #545454;
}

.serp-box p em {
  font-family: Arial, sans-serif;
  font-weight: bold;
  font-style: normal;

  color: #6a6a6a;
}

@media (max-width: 760px) {
  .serp-box cite {
    padding-bottom: 11px;
  }

  .serp-box p {
    margin: 0;
    padding-top: 11px;

    border-top: 1px solid #ebebeb;
  }

  .serp-box p a {
    pointer-events: auto;
  }
}
</style>
